/* eslint-disable no-restricted-globals */
// Stolen from SERP: https://github.com/axel-springer-kugawana/aviv_seeker_classified_search_result_page/blob/main/packages/ads/src/hooks/useLoadHeadScripts.ts
import { useEffect, useCallback, useRef } from "react";
import { brandConfiguration } from "@/brands/config";
import { IS_SERVER } from "@/constants";
import { useIsPubstackEnabled } from "@/components/Ads/utils/utils";
const { ads: advertising, urls: { assets: sharedAssetsUrl }, tracking, } = brandConfiguration || {};
// This hook will append external scripts and styles tags to the head of the document using JS
export const useHead = () => {
    const scriptsLoaded = useRef(false);
    const usePubstack = useIsPubstackEnabled();
    const loadScript = useCallback(({ src = "", func = "", async = true, defer = false, onLoad = () => { }, id, anonymous = false, }) => {
        if (IS_SERVER || (!src && !func))
            return;
        if (document.head.querySelector(`script[src='${src}']`))
            return;
        const script = document.createElement("script");
        script.async = async;
        script.defer = defer;
        if (id) {
            script.id = id;
        }
        if (anonymous) {
            script.crossOrigin = "anonymous";
        }
        if (func) {
            script.innerHTML = func;
            document.head.appendChild(script);
            onLoad();
        }
        else {
            script.src = src;
            script.onload = onLoad;
            document.head.appendChild(script);
        }
    }, []);
    const loadStyle = useCallback((url) => {
        if (IS_SERVER || !url)
            return;
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = url;
        document.head.appendChild(link);
    }, []);
    const loadHarvest = useCallback(() => {
        if (tracking.harvest) {
            window["dataLayer"] = window["dataLayer"] || [];
            window["dataLayer"].push({
                "gtm.start": new Date().getTime(),
                event: "gtm.js",
            });
            // Harvest is based on the Legacy GTM script
            loadScript({
                src: tracking.gtmLegacyUrl,
                async: true,
                id: "GTM-GA3",
            });
        }
    }, [loadScript]);
    useEffect(() => {
        var _a;
        if (scriptsLoaded.current) {
            return;
        }
        if (!((_a = advertising === null || advertising === void 0 ? void 0 : advertising.optimizationScriptUrl) === null || _a === void 0 ? void 0 : _a.includes("pbstck")) ||
            usePubstack) {
            loadScript({
                src: advertising === null || advertising === void 0 ? void 0 : advertising.optimizationScriptUrl,
                async: true,
                id: "advertising-scripts-optimization-url",
                anonymous: true,
            });
        }
        if ((advertising === null || advertising === void 0 ? void 0 : advertising.gptUrl) && !usePubstack) {
            loadScript({
                src: advertising === null || advertising === void 0 ? void 0 : advertising.gptUrl,
                async: true,
                id: "advertising-scripts-gptUrl",
                anonymous: true,
            });
        }
        // SEO scripts to hide links
        loadScript({
            src: `${sharedAssetsUrl}/seoObf.js`,
            async: true,
            id: "aviv.CDP.obf",
        });
        // Mapbox Styles
        loadStyle("https://api.tiles.mapbox.com/mapbox-gl-js/v3.9.2/mapbox-gl.css");
        // Swiper Styles
        loadStyle("https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.css");
        // Datadome CAPTCHA
        loadScript({
            func: `
        window.ddjskey = '8C7191D8AA1BF5FBB1B84DC7268196';
        window.ddoptions = [];
        window.ddoptions.ajaxListenerPath = [ "aws.aviv-internal.eu", "aws.aviv.eu", "immonet.de", "immowelt.de", "seloger.com", "logic-immo.com" ];
        `,
        });
        // Legacy tracking solution for French brands
        loadHarvest();
        scriptsLoaded.current = true;
    }, [loadScript, loadStyle, loadHarvest, usePubstack]);
};
